@if (element) {
<h2 class="co-form__title">{{ section.title }}</h2>
  @for (item of section.items; track trackByItem(item)) {
    <app-tab-item [item]="item" [element]="element"></app-tab-item>
  }
}
